import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'edu-edu-row',
  templateUrl: './edu-row.component.html',
  styleUrls: ['./edu-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EduRowComponent implements OnInit {
  @Input() image: string;
  @Input() text: string;
  constructor() {}

  ngOnInit(): void {}
}
